module.exports = __webpack_public_path__ + "media/svg-new/startOff-9294ce87.svg";